const BLOG = {
    onReady() {
        document.addEventListener('click', BLOG.filterClick);
        document.addEventListener('click', BLOG.loadMore);
    },
    /*********************
    * Filter Click XHR request
    *********************/
    filterClick(event) {
        let filter = event.target.closest('.blog-overview__filter');
        if (filter === null) return;
        event.preventDefault();
        XHR.load({
            nodeIds: [ 'blog-overview' ],
            url: filter.href,
            functionCall: [ MAIN.onReady ]
        });
        window.history.replaceState(null, '', filter.href);
    },
    loadMore(event) {
        let loader = event.target.closest('.blog-load-more');
        if (loader === null) return;
        event.preventDefault();
        XHR.load({
            nodeIds: [ loader.parentNode.id ],
            url: loader.href
        });
        window.history.replaceState(null, '', loader.href);
    }
}